const imgTeamGoodsPackageDominotiles = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img3 = "./assets/figma/67472046-c77c-4ef7-bb78-1bb6338dc39a.png";
const img2026923382 = "./assets/figma/28434674-e6be-4dd7-bed7-6a17cba426a6.png";
const img2026923373 = "./assets/figma/0055b262-7091-4522-ae89-23e7c6b7377a.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const img2 = "./assets/figma/c5bdd390-5d79-4672-98f8-1f5b3c8fdc4c.png";
const img4 = "./assets/figma/010da3b4-d72d-4163-99e7-6a4b720bada6.png";
const img5 = "./assets/figma/a4662698-7b79-4f33-99f8-f08858674d7b.png";
const img6 = "./assets/figma/db7f506e-a322-47fb-9e64-5d315accf954.png";
const img7 = "./assets/figma/837f2275-28a3-4b24-add7-05c89f85c2aa.png";
const img8 = "./assets/figma/733eb77d-7af3-4c7f-8928-bcbfc072e441.png";
const img9 = "./assets/figma/1e24eb93-7025-4225-a4b0-8adf98f725c6.png";
const img10 = "./assets/figma/75e327d2-60fa-430e-8852-636ad18c18f1.png";
const img11 = "./assets/figma/fbcd2ba2-ae8d-45be-9dcb-25653a2ec552.png";
const img12 = "./assets/figma/fb83750a-a391-4af6-b9e8-b79341cca164.png";
const imgGpt1 = "./assets/figma/7d702eab-a061-4224-9826-e12c2c9aeedd.png";
const imgGrok1 = "./assets/figma/f9c184b5-59d0-46ca-afe4-365e98ae6576.png";
const imgGemini1 = "./assets/figma/57cad273-068e-498f-a172-e2b42c51952c.png";
const imgHiggsfield1 = "./assets/figma/3cf53e39-4db4-4cae-ba9a-83439df2640e.png";
const imgManus1 = "./assets/figma/7282f299-c52e-4882-9d9c-b0b1b8ef91ff.png";
const imgMidjourney1 = "./assets/figma/69933abd-a1b8-4038-99b0-7bd4eb9719b5.png";
const imgRunway1 = "./assets/figma/e8a58450-0fde-4de4-9144-42c4e6cfeb58.png";
const img13 = "./assets/figma/a3c641b3-cad1-4b5e-a3b1-3ce76b20d44b.png";
const imgClaude1 = "./assets/figma/eae15c5a-ad3f-46e9-9a93-d4c5f14204dd.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/0910cb02-95b1-474b-946c-10878436c4c0.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle243 = "./assets/figma/0dfb52b6-ae5c-4986-8e59-80bb7d314ca8.svg";
const imgRectangle246 = "./assets/figma/0f75945d-c052-4259-ba44-5c51f8242788.svg";
const imgClose = "./assets/figma/81bd588e-f50c-4a63-9123-f96186e07ecb.svg";

export default function TeamGoodsPackageDominotiles() {
  return (
    <div className="s0 s1" data-node-id="867:6325" data-name="TEAM_GOODS/PACKAGE/DOMINOTILES">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s7 s321 s9 s10 s322" src={imgTeamGoodsPackageDominotiles} />
        </div>
      </div>
      <div className="s2 s12 s13 s14 s15" data-node-id="867:6328" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s20 s323 s22" data-node-id="867:6329">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="867:6330">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="867:6331">
            PROJECT OVERVIEW
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="867:6332">
            DOMINO TILES · 30 × 48 × 5 MM · 15
            <br aria-hidden />
            GAME BOARD · 550 × 550 MM · 1<br aria-hidden />
            CARDS · 63 × 88 MM · 20
            <br aria-hidden />
            INSTRUCTION PANEL
          </p>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="867:6333">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="867:6334">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="867:6335">
            MEMBERS
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="867:6336">
            신지수
            <br aria-hidden />
            윤현서
            <br aria-hidden />
            지윤주
            <br aria-hidden />
            홍민지
          </p>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s324 s54" data-node-id="867:6337">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s55 s27 s29 s325 s57" data-node-id="867:6338">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="867:6339">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="867:6340">
          <p className="s39 s40">{`패키지/굿즈팀은 원하는 결과에 도달하기 위해 AI를 선택하고 조합하는 과정을 도미노 보드게임 패키지로 `}</p>
          <p className="s39 s40">{`시각화했다. 2~4명의 플레이어는 게임 시작 시 결과 구슬 카드를 뽑아 목표를 정하고 AI 도미노를 나누어 가진다. `}</p>
          <p className="s39 s40">{`이후 카드에 제시된 조건에 맞는 도미노를 골라 순서대로 연결하며 각자의 AI 파이프라인을 구성한다. `}</p>
          <p className="s39 s40">{`조건을 가장 먼저 충족해 도미노 라인을 완성한 플레이어가 승리하고, 완성된 도미노를 직접 쓰러뜨리며 AI의 `}</p>
          <p className="s39">선택과 조합에서 결과 도출까지 이어지는 과정을 놀이로 경험하도록 제작했다.</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s326 s27 s29 s61 s62 s54" data-node-id="867:6341">
        GOODS/PACKAGE
      </p>
      <div className="s2 s17 s327 s18 s42 s328 s325 s329" data-node-id="867:6342">
        <div className="s330 s44 s331">
          <div className="s327 s0 s329" data-name="패키지팀 3">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img3} />
          </div>
        </div>
      </div>
      <div className="s2 s16 s17 s24 s332 s26 s20 s333 s334" data-node-id="867:6343">
        <p className="s23 s31 s32 s27 s0 s28 s29 s64 s34" data-node-id="867:6344">
          WORK
        </p>
        <div className="s16 s17 s18 s19 s36 s0 s28 s34" data-node-id="867:6345" data-name="TEAM_GOODS/PACKAGE_WORK">
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="867:6346">
            <div className="s192 s335 s336 s337 s339 s340 s338 s0 s198" data-node-id="867:6347">
              <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="867:6348" data-name="이미지 2026. 9. 2. 오후 3.38 2">
                <div className="s2 s3 s6 s4 s70">
                  <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
                </div>
              </div>
              <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="867:6349" />
            </div>
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="867:6350" />
            <p className="s23 s192 s31 s32 s345 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="867:6351">
              DOMINO TILES
            </p>
          </div>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="867:6352">
            <div className="s192 s17 s69 s18 s42 s339 s340 s0 s198 s71" data-node-id="867:6353">
              <div className="s330 s44 s331">
                <div className="s69 s0 s70 s71" data-name="패키지팀 4">
                  <img alt="" className="s2 s3 s9 s105 s4 s70 s1" src={img3} />
                </div>
              </div>
            </div>
            <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="867:6354" />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="867:6355" />
            <div className="s23 s192 s31 s347 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="867:6356">
              <p className="s94 s40">GAME BOARD</p>
              <p className="s94">INSTRUCTION PANEL</p>
            </div>
          </div>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="867:6357">
            <div className="s192 s69 s339 s340 s0 s70 s198 s348 s71" data-node-id="867:6358" data-name="이미지 2026. 9. 2. 오후 3.37 3">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s349 s350 s9 s10 s351" src={img2026923373} />
              </div>
            </div>
            <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="867:6359" />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="867:6360" />
            <p className="s23 s192 s31 s94 s352 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="867:6361">
              CARDS
            </p>
          </div>
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="867:6362">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="867:6363" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="867:6364">
          <div className="s111 s0 s28 s112" data-node-id="867:6365" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="867:6370">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="867:6371">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="867:6372">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="867:6373">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="867:6374">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="867:6375">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="867:6376">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="867:6377">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="867:6378">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="867:6379">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="867:6380">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s2 s353 s354 s10 s104" data-node-id="863:5617">
        <div className="s2 s355">
          <img alt="" className="s49 s9 s1" src={imgRectangle243} />
        </div>
      </div>
      <div className="s106 s2 s128 s126 s10 s104" data-node-id="875:495">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle246} />
        </div>
      </div>
      <div className="s106 s2 s67 s126 s356" data-node-id="875:330">
        <div className="s2 s5 s357 s153 s156 s157 s356 s158" data-node-id="863:5721" />
        <div className="s2 s415 s416 s417 s418" data-node-id="863:5722" data-name="도미노 목업 2">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s7 s419 s9 s10 s420" src={img2} />
          </div>
        </div>
        <p className="s23 s2 s31 s32 s421 s27 s29 s160 s359 s54" data-node-id="863:5723">
          DOMINO TILEs
        </p>
        <p className="s23 s2 s31 s32 s360 s27 s29 s137 s361 s54" data-node-id="863:5724">
          DOMINO TILES DESIGN
        </p>
        <div className="s106 s2 s67 s256 s371" data-node-id="863:5733">
          <div className="s106 s2 s372 s256 s165 s4 s145 s146 s371 s373" data-node-id="863:5734">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s374 s26 s375 s27 s29 s376 s377" data-node-id="863:5735">
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="863:5736">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="863:5737">
                Prompt
              </p>
              <div className="s35 s36 s0 s28 s174 s34 s38" data-node-id="863:5738">
                <p className="s175 s40">Create a photorealistic 3D product mockup using the existing domino image as the BASE IMAGE.Preserve the existing domino object exactly: same size, proportions, thickness, position, camera angle, 3/4 perspective, top face, side face, side color, side logo, background, lighting, reflections, shadows, and overall composition.Preserve the domino corner geometry according to the supplied corner reference: small-radius molded corners, restrained rounding, subtle bevel, relatively straight and crisp edges, not overly rounded.ONLY replace the pipe-graphic artwork on the front face.Use the supplied pipe-graphic image as FINAL PRODUCTION ARTWORK, not as a style reference.Treat the complete supplied graphic as one fixed planar graphic asset.Preserve exactly: all pipe geometry, pipe count, connector positions, logos, typography, symbols, colors, spacing, proportions, orientation, and internal relationships.Apply ONLY the perspective transformation required to make the entire graphic conform to the existing domino front plane.The horizontal direction of the pipe graphic must follow the exact perspective direction of the domino front face.The graphic must sit flush on the domino front surface, with no floating panel and no independent front-facing orientation.Keep the side face completely unchanged, including its exact color and logo.Keep the background pure white and unchanged.The final image must look like the original domino photograph with only the front pipe artwork replaced by the supplied graphic.25. 최종 우선순위26. 기존 도미노 형태 보존27. 도미노 모서리 형태와 라운딩 보존28. 옆면 로고와 색상 보존29. 화이트 배경 보존30. 기존 카메라와 투시 보존31. 파이프 그래픽 전체를 고정 그래픽으로 취급32. 그래픽 전체에 도미노 전면의 투시만 적용33. 그래픽 내부의 형태, 로고, 텍스트, 구조 유지CHANGE ONLY THE FRONT PIPE GRAPHIC. PRESERVE EVERYTHING ELSE EXACTLY.</p>
                <p className="s175 s40">​</p>
                <p className="s175">Do not copy the graphics or colors from Reference C.Do not change the Base Image’s domino size, width-to-height ratio, thickness, position, camera distance, 3/4 angle, top face, or side face.Do not create overly rounded, toy-like corners.Do not change the domino’s overall size or perspective.Do not change the side-face color, logo, logo position, logo orientation, side-face width, or perspective.Do not change any area other than the pipe graphic on the front face.Do not redraw or reconstruct the internal structure of the supplied graphic.Do not redesign, reinterpret, redraw, regenerate, simplify, stylize, mirror, rotate, replace, add, remove, or rearrange any part of the supplied graphic.Do not change the typography, logo, pipe geometry, pipe count, joint structure, connector positions, symbols, colors, spacing, proportions, orientation, or internal relationships.Do not make the graphic look like an independent front-facing panel.Do not place the terminal sleeve and primary joint directly together.Do not add a separate joint to the transparent straight buffer section.</p>
              </div>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="863:5739">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="863:5740">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="863:5741">
                Chat GPT
              </p>
            </div>
          </div>
        </div>
        <div className="s2 s422 s423 s424 s425 s337 s426 s427" data-node-id="863:5742">
          <div className="s192 s428 s0 s198 s28 s429" data-node-id="863:5743" data-name="챗지피티 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img4} />
          </div>
          <div className="s203 s428 s0 s198 s28 s429" data-node-id="863:5744" data-name="클로드 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img5} />
          </div>
          <div className="s205 s428 s0 s198 s28 s429" data-node-id="863:5745" data-name="제미나이 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img6} />
          </div>
          <div className="s192 s428 s0 s206 s28 s429" data-node-id="863:5746" data-name="미드저니 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img7} />
          </div>
          <div className="s203 s428 s0 s206 s28 s429" data-node-id="863:5747" data-name="뒷면 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img8} />
          </div>
          <div className="s205 s428 s0 s206 s28 s429" data-node-id="863:5748" data-name="그록 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img9} />
          </div>
          <div className="s192 s428 s0 s430 s28 s429" data-node-id="863:5749" data-name="런웨이 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img10} />
          </div>
          <div className="s203 s428 s0 s430 s28 s429" data-node-id="863:5750" data-name="힉스필드 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img11} />
          </div>
          <div className="s205 s428 s0 s430 s28 s429" data-node-id="863:5751" data-name="마누스 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img12} />
          </div>
        </div>
        <div className="s2 s431 s432 s185 s186 s433 s434 s435 s402 s436" data-node-id="863:5752">
          <div className="s192 s17 s18 s42 s197 s0 s198 s199 s28" data-node-id="863:5753" style={{ containerType: "size" }}>
            <div className="s44 s437 s45 s438">
              <div className="s0 s1" data-name="gpt 1">
                <img alt="" className="s2 s3 s9 s439 s4 s1" src={imgGpt1} />
              </div>
            </div>
          </div>
          <div className="s203 s197 s0 s198 s199 s28" data-node-id="863:5754" data-name="grok 1">
            <img alt="" className="s2 s3 s9 s439 s4 s1" src={imgGrok1} />
          </div>
          <div className="s205 s197 s0 s198 s199 s28" data-node-id="863:5755" data-name="gemini 1">
            <img alt="" className="s2 s3 s9 s439 s4 s1" src={imgGemini1} />
          </div>
          <div className="s192 s17 s18 s42 s197 s0 s206 s199 s28" data-node-id="863:5756" style={{ containerType: "size" }}>
            <div className="s44 s437 s45 s438">
              <div className="s0 s1" data-name="higgsfield 1">
                <img alt="" className="s2 s3 s9 s439 s4 s1" src={imgHiggsfield1} />
              </div>
            </div>
          </div>
          <div className="s203 s197 s0 s206 s199 s28" data-node-id="863:5757" data-name="manus 1">
            <img alt="" className="s2 s3 s9 s439 s4 s1" src={imgManus1} />
          </div>
          <div className="s205 s197 s0 s206 s199 s28" data-node-id="863:5758" data-name="midjourney 1">
            <img alt="" className="s2 s3 s9 s439 s4 s1" src={imgMidjourney1} />
          </div>
          <div className="s192 s197 s0 s430 s199 s28" data-node-id="863:5759" data-name="runway 1">
            <img alt="" className="s2 s3 s9 s439 s4 s1" src={imgRunway1} />
          </div>
          <div className="s205 s197 s0 s430 s199 s28" data-node-id="863:5760" data-name="도미노 뒷면 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={img13} />
          </div>
          <div className="s203 s197 s0 s430 s199 s28" data-node-id="863:5761" data-name="claude 1">
            <img alt="" className="s2 s3 s9 s439 s4 s1" src={imgClaude1} />
          </div>
        </div>
      </div>
      <div className="s2 s16 s17 s24 s378 s26 s20 s132 s133" data-node-id="875:134" data-name="PROJECT_CATEGORY_TABS_GOODS/PACKAGE">
        <p className="s23 s31 s32 s379 s27 s0 s28 s58 s138 s380" data-node-id="863:5618">
          GOODS/PACKAGE
        </p>
        <div className="s16 s17 s139 s18 s0 s28 s140" data-node-id="863:5725" data-name="PROJECT_CATEGORY_TABS_GOODS/PACKAGE">
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="863:5726" data-name="TAB_DOMINO_TILES">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="863:5727">
              DOMINO TILES
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="863:5728" data-name="TAB_GAMEBOARD">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="863:5729">
              GAME BOARD
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="863:5730" data-name="TAB_CARDS">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="863:5731">
              CARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
        </div>
      </div>
      <button className="s2 s49 s141 s211 s212 s213" data-node-id="891:150" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
    </div>
  );
}